<template>
  <v-dialog 
    v-model="navigation.mediaDialogIsVisible" 
    @update:model-value="navigation.mediaDialogIsVisible == false ? closeMediaDialog() : null" 
    max-width="60vw"
    style="user-select: none; cursor: default;"
  >        
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-attachment</v-icon>
            <h3>{{ { 'webp': 'IMAGEN', 'gif': 'IMAGEN', 'mp4': 'VIDEO' }[display.mediaExtension] }}</h3>
            <p style="font-size: small; color: #9e9e9e;">({{ display.mediaName }}.{{ display.mediaExtension }})</p>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="downloadMedia()"
              :disabled="loader.downloadMedia"
              color="indigo" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-download-circle</v-icon>
              <p>DESCARGAR</p>
            </v-btn>
            <v-btn 
              @click="closeMediaDialog()"
              :disabled="loader.downloadMedia"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div class="mediaContainer">
        <img 
          v-if="display.mediaExtension == 'webp' || display.mediaExtension == 'gif'"
          :src="display.mediaURL || require('@/assets/images/ProductPicturePlaceholder.png')"
          draggable="false"
          class="mediaElement"
        >
        <video 
          v-else-if="display.mediaExtension == 'mp4'" 
          :src="display.mediaURL"
          controls 
          class="mediaElement"
        ></video>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.headerCard {
  padding: 15px;
  display: grid;
  justify-content: center;
  align-items: center;
  gap: 10px;
  grid-template-columns: repeat(2, 1fr);
}

.titleContainer {
  display: flex;
  align-items: center;
  gap: 10px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.mediaContainer {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* evita scroll */
  background-color: #fafafa;
  padding: 10px;
}

.mediaElement {
  max-width: 100%;
  max-height: calc(90vh - 120px);
  width: auto;
  height: auto;
  object-fit: contain;
}

@media (max-width: 1200px) {
  .headerCard {
    grid-template-columns: 1fr;
  }
  .titleContainer {
    justify-content: center;
  }
  .actionsContainer {
    justify-content: center;
    margin-left: 0;
  }
}
</style>

<script>
  export default {
    data: () => 
    ({
      display: 
      {
        mediaURL: null,
        mediaName: null,
        mediaExtension: null
      },
      navigation: 
      {
        mediaDialogIsVisible: false
      },
      loader: 
      {
        downloadMedia: false
      }
    }),
    methods:
    {
      async downloadMedia() {
        try {
          this.loader.downloadMedia = true;
          const downloadMediaResponse = await fetch(this.display.mediaURL);
          const downloadMediaBlob = await downloadMediaResponse.blob();
          const downloadMediaBlobURL = window.URL.createObjectURL(downloadMediaBlob);
          const downloadMediaURL = document.createElement('a');
          downloadMediaURL.href = downloadMediaBlobURL;
          downloadMediaURL.download = this.display.mediaName || 'archivo';
          document.body.appendChild(downloadMediaURL);
          downloadMediaURL.click();
          document.body.removeChild(downloadMediaURL);
          window.URL.revokeObjectURL(downloadMediaBlobURL);
        } catch (error) {
          console.error('Error al descargar el archivo:', error);
        } finally {
          this.loader.downloadMedia = false;
        }
      },
      openMediaDialog(mediaURL, mediaName, mediaExtension){
        this.display.mediaURL = mediaURL;
        this.display.mediaName = mediaName;
        this.display.mediaExtension = mediaExtension;
        this.loader.downloadMedia = false;
        this.navigation.mediaDialogIsVisible = true;
      },
      closeMediaDialog(){
        this.navigation.mediaDialogIsVisible = false;
        this.$emit('closeMediaDialog');
      }
    }
  }
</script>